import React, { Component } from 'react';
import Docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import PizZipUtils from 'pizzip/utils/index.js';
import { saveAs } from 'file-saver';
import expressionParser from 'docxtemplater/expressions';

function loadFile(url, callback) {
  PizZipUtils.getBinaryContent(url, callback);
}

class PDFGenerator extends Component {
  generateDocument = () => {
    loadFile(
      'https://docxtemplater.com/ang-example.docx',
      function (error, content) {
        if (error) {
          throw error;
        }
        const zip = new PizZip(content);
        const doc = new Docxtemplater(zip, {
          paragraphLoop: true,
          linebreaks: true,
          parser: expressionParser,
        });
        // doc.render({
        //   first_name: 'John',
        //   last_name: 'Doe',
        //   organization: {
        //     companyName: 'Foobar',
        //   },
        //   phone: '0652455478',
        //   description: 'New Website',
        // });
        const data = {
          provider_name_license: 'Provider Name and license Number',
          beneficiary_name: 'Beneficiary Name',
          document_id: 'Document Type - Document ID',
          insurance_company: 'Insurance Company Name / TPA',
          insurance_id: 'Insurance ID',
          beneficiary_age: 'Calculated from date of birth',
          beneficiary_gender: 'Gender',
          relationship: 'Relationship',
          contact_number: 'Beneficiary\'s phone number',
        };
        doc.render(data);
        const out = doc.getZip().generate({
          type: 'blob',
          mimeType:
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        });
        saveAs(out, 'output.docx');
      }
    );
  };

  render() {
    return null; 
  }
}

export default PDFGenerator;

